const ourPromise = {
  description:
    'We bring the world’s best designer and luxury fashion at the best price, and provide a platform to discover new luxury brands and designer talent.',
  title: 'Our Promise | italist is committed to you',
};

export default ourPromise;
